import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ResultReportsListingModel } from 'common/models/page-models/reports/result-reports/result-report-grid.model';
import { ResultReportsModel } from 'common/models/page-models/reports/result-reports/result-reports-data.model';
import { ReportFilterMetaModel } from 'common/models/page-models/reports/result-reports/result-reports-filter-meta.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { ResultReportsWidgetService } from 'common/widget/reports/result-reports.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class ResultReportsResolver extends GridResolver<ResultReportsModel, ResultReportsListingModel> {
    constructor(
        protected fs: ResultReportsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    
    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.filterData = new ResultReportsModel();
        transferData.filterMeta = new ReportFilterMetaModel().getMetaModel();
        this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
}